import {Dialog} from "@mui/material";
import styled from 'styled-components';
import {tokens} from "../../theme";

export const StyledDialog = styled(Dialog)`
    .MuiPaper-root {
        min-width: 500px;
        width: 800px;
    }
`;

export const ModalHeader = styled.h3`
    font-family: ${({theme}) => theme.typography.fontFamily};
    padding: 16px 24px;
    font-size: ${tokens.fontSize.lg};
    font-weight: ${tokens.fontWeight.semibold};
    margin: 0;
    text-align: left;
    color: ${({theme}) => theme.palette.text.primary};
`;

export const ModalBody = styled.div`
    font-family: ${({theme}) => theme.typography.fontFamily};
    padding: 40px 48px !important;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const ModalFooter = styled.div`
    font-family: ${({theme}) => theme.typography.fontFamily};
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 20px 24px !important;
`;

export const Input = styled.input`
    display: none;
    @media (max-width: 600px) {
        input {
            padding-left: 0;
        }
    }
`;

export const CustomFileButton = styled.button`
    background: ${({theme}) => theme.palette.secondary.main};
    color: ${({theme}) => theme.palette.secondary.contrastText};
    border: none;
    border-radius: ${tokens.radius.xl};
    
    margin-top: 16px;
    padding: 12px 24px;
    cursor: pointer;
    
    transition: background 0.2s ease-in-out;
    
    font-weight: ${tokens.fontWeight.medium};
    font-family: ${({theme}) => theme.typography.fontFamily};
    font-size: ${tokens.fontSize.base};
    
    &:hover {
        background: ${({theme}) => theme.palette.secondary.dark};
    }

    &:disabled {
        background: ${({theme}) => theme.palette.action.disabledBackground};
        cursor: not-allowed;
    }
`;

export const DropZone = styled.div<{ $isDraggingOver: boolean }>`
    border: 2px dashed ${
        (props) => (props.$isDraggingOver 
                ? ({ theme }) => theme.palette.dividers.focus
                : ({ theme }) => theme.palette.dividers.default)
    };
    border-radius: ${tokens.radius.sm};
    background: ${
        (props) => (props.$isDraggingOver 
            ? ({theme}) => theme.palette.action.hoveredDropzone
            : ({theme}) => theme.palette.background.dropzone)
    };
    padding: 32px;
    text-align: center;
    transition: all 0.2s ease-in-out;
    margin-bottom: 16px;
    cursor: pointer;

    p {
        margin: 0;
        color: ${(props) => (props.$isDraggingOver
                ? ({ theme }) => theme.palette.action.dragDrop
                : ({ theme }) => theme.palette.text.secondary
        )};
    }
`;
